var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(
            _vm.useRouter &&
            _vm.contact.encoded_id &&
            (_vm.contact.type === 'business' || _vm.type === 'business')
        )?_c('router-link',{attrs:{"to":{
            name: 'contact_company',
            params: { id: _vm.contact.encoded_id }
        }}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]):(
            _vm.useRouter &&
            _vm.contact.encoded_id &&
            (_vm.contact.type !== 'business' || _vm.type !== 'business')
        )?_c('router-link',{attrs:{"to":{ name: 'contact_actor', params: { id: _vm.contact.encoded_id } }}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]):(_vm.contact.encoded_id)?_c('a',{attrs:{"href":_vm.contactUrl}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('input',{attrs:{"type":"hidden","name":"contact-id"},domProps:{"value":_vm.contact.id ? _vm.contact.id : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }